export var isHtmlInputElement = function isHtmlInputElement(e) {
  return Object.keys(e).includes('value');
};